import * as React from 'react'

function SvgWireUnchecked(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path d="m29 12.414-2.293 2.293-1.414-1.414L27.586 11l-2.293-2.293 1.414-1.414L29 9.586l2.293-2.293 1.414 1.414L30.414 11l2.293 2.293-1.414 1.414L29 12.414Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 11c0-.078.001-.156.003-.233A2.989 2.989 0 0 0 18 10h-4a2 2 0 0 0-2 2v1h-2a1 1 0 1 0 0 2h2v2h-2a1 1 0 1 0 0 2h2v1a2 2 0 0 0 2 2h4a3 3 0 0 0 3-3v-1.998c.333.01.82.029 1.352.064A8.968 8.968 0 0 1 20 11Zm-2 1h-4v8h4a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1Z"
      />
      <path d="M26.994 19.776A9.035 9.035 0 0 0 29 20c-.003 1.352-.623 2.307-1.47 2.982-.793.633-1.811 1.04-2.664 1.376l-.128.05c-.863.339-1.56.612-2.07.97-.476.335-.668.655-.668 1.112 0 .67.185 1.085.431 1.372.261.305.668.553 1.247.737 1.198.381 4.778.39 6.322.39a1 1 0 1 1 0 2h-.08c-1.446 0-5.324.001-6.848-.484-.796-.253-1.577-.661-2.16-1.341-.597-.698-.912-1.594-.912-2.674 0-1.294.683-2.16 1.519-2.748.716-.503 1.63-.86 2.417-1.168l.198-.078c.897-.352 1.629-.663 2.149-1.077.463-.37.717-.787.717-1.43 0-.073-.002-.144-.006-.213Z" />
    </svg>
  )
}

export default SvgWireUnchecked
